
import { Layout, Share2, Users, CheckCircle } from "lucide-react";

const AuthFeatures = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold mb-4">Welcome to EZ Flow Chart</h1>
        <p className="text-lg text-gray-600 mb-6">
          Join thousands of professionals creating beautiful flow charts with our intuitive platform.
        </p>
      </div>

      <div className="space-y-6">
        <div className="flex gap-4">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Layout className="text-primary h-5 w-5" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Intuitive Design</h3>
            <p className="text-gray-600 text-sm">Create professional flow charts in minutes with our easy-to-use drag-and-drop interface.</p>
          </div>
        </div>

        <div className="flex gap-4">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Users className="text-primary h-5 w-5" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Real-time Collaboration</h3>
            <p className="text-gray-600 text-sm">Work together with your team seamlessly with live updates and instant syncing.</p>
          </div>
        </div>

        <div className="flex gap-4">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Share2 className="text-primary h-5 w-5" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">Works Offline</h3>
            <p className="text-gray-600 text-sm">Continue working even without internet connection, with automatic sync when you're back online.</p>
          </div>
        </div>
      </div>

      <div className="bg-primary/5 rounded-lg p-6">
        <h3 className="font-semibold mb-3 flex items-center gap-2">
          <CheckCircle className="h-5 w-5 text-primary" />
          What you get:
        </h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>• Unlimited flow charts and diagrams</li>
          <li>• Professional templates and shapes</li>
          <li>• Export to PDF, PNG, and other formats</li>
          <li>• Team collaboration features</li>
          <li>• Cloud storage and backup</li>
        </ul>
      </div>
    </div>
  );
};

export default AuthFeatures;
